import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiNoCacheRequestInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.match('^.*customer-api.*$')) {
      request = request.clone({ setHeaders : {
        'Cache-Control' : 'no-cache',
        'Pragma' : 'no-cache',
        'Expires' : '0'
      }});
    }
    return next.handle(request);
  }
}
